import ReportSetting from "../ReportSetting";
import OrderStatusReason from "../../Utility/Crud/OrderStatusReason";
import MUIStack from "@mui/material/Stack";
import MUIAutocomplete from "@mui/material/Autocomplete";
import MUITextField from "@mui/material/TextField";
import InfoItem from "../InfoItem";
import MainContext from "../../Context/MainContext/MainContext";

export default class ReportSettingOrderStatusReasonMapping extends ReportSetting {
  static contextType = MainContext; // For legacy class components
  /**
   *  Renders a dropdown of old order status reasons.
   *
   **/
  renderOldOrderStatusDropdown() {
    const handleOrderStatusReasonChange = (e, orderStatusReasons) => {
      this.handleSettingChange(
        "oldOrderStatusReasonIds",
        orderStatusReasons.map((orderStatusReason) => orderStatusReason.id),
      );
    };

    return (
      <MUIAutocomplete
        multiple={true}
        options={OrderStatusReason.sort(
          Object.values(this.context.orderStatusReasonsIndexed),
        )}
        getOptionLabel={(option) => OrderStatusReason.getDisplayName(option)}
        isOptionEqualToValue={(option, value) => option.id === value.id}
        value={OrderStatusReason.read(this.context.orderStatusReasonsIndexed, [
          {
            key: "id",
            value: this.state.settings.oldOrderStatusReasonIds || [],
          },
        ])}
        onChange={handleOrderStatusReasonChange}
        sx={{ width: "300px" }}
        renderInput={(params) => (
          <MUITextField
            {...params}
            size="small"
            label="Old Reason"
            variant="standard"
            InputLabelProps={{ shrink: true }}
          />
        )}
      />
    );
  }

  /**
   *  Renders a dropdown of new order status reasons.
   *
   **/
  renderNewOrderStatusDropdown() {
    const handleOrderStatusReasonChange = (e, orderStatusReasons) => {
      this.handleSettingChange(
        "newOrderStatusReasonIds",
        orderStatusReasons.map((orderStatusReason) => orderStatusReason.id),
      );
    };

    return (
      <MUIAutocomplete
        multiple={true}
        options={OrderStatusReason.sort(
          Object.values(this.context.orderStatusReasonsIndexed),
        )}
        getOptionLabel={(option) => OrderStatusReason.getDisplayName(option)}
        isOptionEqualToValue={(option, value) => option.id === value.id}
        value={OrderStatusReason.read(this.context.orderStatusReasonsIndexed, [
          {
            key: "id",
            value: this.state.settings.newOrderStatusReasonIds || [],
          },
        ])}
        onChange={handleOrderStatusReasonChange}
        sx={{ width: "300px" }}
        renderInput={(params) => (
          <MUITextField
            {...params}
            size="small"
            label="New Reason"
            variant="standard"
            InputLabelProps={{ shrink: true }}
          />
        )}
      />
    );
  }

  renderContent() {
    return (
      <MUIStack
        direction="row"
        spacing={2}
        sx={{
          alignItems: "center",
        }}
      >
        {this.renderOldOrderStatusDropdown()}
        {this.renderNewOrderStatusDropdown()}
      </MUIStack>
    );
  }

  renderReadOnly() {
    const oldReasons =
      this.state.settings.oldOrderStatusReasonIds &&
      this.state.settings.oldOrderStatusReasonIds.length > 0
        ? OrderStatusReason.read(this.context.orderStatusReasonsIndexed, [
            { key: "id", value: this.state.settings.oldOrderStatusReasonIds },
          ])
        : [];

    const newReasons =
      this.state.settings.newOrderStatusReasonIds &&
      this.state.settings.newOrderStatusReasonIds.length > 0
        ? OrderStatusReason.read(this.context.orderStatusReasonsIndexed, [
            { key: "id", value: this.state.settings.newOrderStatusReasonIds },
          ])
        : [];

    const oldReasonValue =
      oldReasons.length === 0
        ? "None"
        : oldReasons
            .map((reason) => OrderStatusReason.getDisplayName(reason))
            .join(", ");

    const newReasonValue =
      newReasons.length === 0
        ? "None"
        : newReasons
            .map((reason) => OrderStatusReason.getDisplayName(reason))
            .join(", ");

    return (
      <>
        <InfoItem label="Old Reason" value={oldReasonValue} />
        <InfoItem label="New Reason" value={newReasonValue} />
      </>
    );
  }
}
